import Extend from 'flarum/common/extenders';
import PortalPage from './components/PortalPage';
export default [
// Имя и путь совпадают с backend-маршрутом, поэтому SSR и клиентская навигация ведут на одну страницу.
new Extend.Routes().add('devconnect.portal', '/portal', PortalPage)];